import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function AdminUsers() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/admin/users").then(({ data }) => setItems(data.items));
    useEffect(() => { load(); }, []);

    const setRole = async (user_id, role) => {
        try { await api.patch(`/admin/users/${user_id}`, { role }); toast.success("Updated"); load(); } catch { toast.error("Failed"); }
    };

    return (
        <div data-testid="admin-users">
            <div className="font-mono-brand text-xs uppercase tracking-[0.25em] text-[hsl(var(--ink-soft))]">Team</div>
            <h1 className="mt-1 font-display text-4xl uppercase italic text-[hsl(var(--ink))]">Users</h1>
            <div className="mt-6 overflow-x-auto border-2 border-[hsl(var(--ink))] bg-card">
                <table className="w-full font-mono-brand text-xs">
                    <thead className="bg-[hsl(var(--ink))] text-[hsl(var(--dust-50))]">
                        <tr>{["When", "Name", "Email", "Provider", "Role", ""].map((h) => (
                            <th key={h} className="px-3 py-2 text-left font-heading text-xs uppercase tracking-wider">{h}</th>
                        ))}</tr>
                    </thead>
                    <tbody>
                        {items.map((u) => (
                            <tr key={u.user_id} className="border-t border-[hsl(var(--dust-300))]" data-testid={`admin-user-row-${u.user_id}`}>
                                <td className="px-3 py-2 whitespace-nowrap">{new Date(u.created_at).toLocaleDateString()}</td>
                                <td className="px-3 py-2 font-sans">{u.name}</td>
                                <td className="px-3 py-2">{u.email}</td>
                                <td className="px-3 py-2">{u.provider}</td>
                                <td className="px-3 py-2 uppercase">{u.role}</td>
                                <td className="px-3 py-2 text-right">
                                    {u.role === "user" ? (
                                        <button onClick={() => setRole(u.user_id, "admin")} className="underline underline-offset-4 hover:text-[hsl(var(--forest))]">Promote to admin</button>
                                    ) : (
                                        <button onClick={() => setRole(u.user_id, "user")} className="underline underline-offset-4 hover:text-[hsl(var(--danger))]">Revoke admin</button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
